import api from '../../services/api';

export default {
  state: {
    filter: {
      initiator: '',
      chart_id: ''
    },
    isFilterOpened: false,
    chartOfAccounts: {},
    wallets: [],
    currentWallet: {},
    programPostings: [],
  },
  getters: {
    getWallets(state) {
      return [...state.wallets.map(
        elem => elem.name
      )]
    },
    getChartOfAccounts(state) {
      return state.chartOfAccounts
    },
  },
  mutations: {
    setCharOfAccounts(state, payload) {
      state.chartOfAccounts = payload
    },
    setWallets(state, payload) {
      state.wallets = payload
    },
    setFilterOpened(state, payload) {
      state.isFilterOpened = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    },
    setProgramPostings(state,payload) {
      state.programPostings = payload
    },
  },
  actions: {
    async apiGetWallets({state, commit}) {
      const result = await api.get('acct/wallets')
      commit("setWallets", result.data)
      return result.data
    },
    async apiGetChartOfAccounts({commit},payload) {
      const result = await api.get(`/acct/chart_of_accounts?chart_id=${payload}`,)
      commit("setCharOfAccounts", result.data)
      return result
    },
    async apiGetProgramPostings({commit},payload) {
      if (payload.page) {
        payload.page = payload.page - 1;
      }
      const result = await api.get(`/acct/postings`, {params: payload})
      commit("setProgramPostings", result.data)
      return result
    }
  }
}
